import { cn } from "@/components/ui/cn";

/**
 * HireGen mark: a solid monogram tile — bold H pill with a mint signal node at
 * the crossbar's heart. One gradient, one accent: scales from 16px favicon to
 * the sidebar wordmark without losing shape.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 40 40" className={className} role="img" aria-label="HireGen">
      <defs>
        <linearGradient id="hiregen-tile" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#14b8a6" />
          <stop offset="55%" stopColor="#0f766e" />
          <stop offset="100%" stopColor="#042f2e" />
        </linearGradient>
        <radialGradient id="hiregen-node" cx="35%" cy="35%" r="70%">
          <stop offset="0%" stopColor="#a7f3d0" />
          <stop offset="100%" stopColor="#10b981" />
        </radialGradient>
      </defs>
      {/* tile */}
      <rect x="1.5" y="1.5" width="37" height="37" rx="11" fill="url(#hiregen-tile)" />
      <rect x="1.5" y="1.5" width="37" height="37" rx="11" fill="none" stroke="#ffffff" strokeOpacity="0.09" strokeWidth="1" />
      {/* monogram H — stems and crossbar */}
      <path d="M13.5 12v16M26.5 12v16" stroke="#ffffff" strokeWidth="3.1" strokeLinecap="round" />
      <path d="M13.5 20h9.4" stroke="#ffffff" strokeWidth="3.1" strokeLinecap="round" />
      {/* signal node at the heart of the crossbar */}
      <circle cx="26.5" cy="20" r="4.6" fill="#10b981" fillOpacity="0.22" />
      <circle cx="26.5" cy="20" r="2.35" fill="url(#hiregen-node)" stroke="#042f2e" strokeOpacity="0.35" strokeWidth="0.6" />
    </svg>
  );
}

export function Logo({
  className,
  showText = true,
}: {
  className?: string;
  showText?: boolean;
}) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <LogoMark className="h-9 w-9 shrink-0 drop-shadow-sm" />
      {showText && (
        <div className="min-w-0 leading-tight">
          <p className="text-ink-strong text-[17px] font-extrabold tracking-tight">
            Hire<span className="text-primary font-black">Gen</span>
          </p>
          <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-muted-foreground truncate">
            Leads Intelligence Platform
          </p>
        </div>
      )}
    </div>
  );
}
